import {
  TimesheetBalanceFragment,
  TimesheetEstimatedTimeFragment,
} from 'generated/resources/graphql'

import { AggregatedWorkedTimeBlocks } from './AttendanceWorkedTimeUtils'

export const calculateTimesheetBalanceBreakdown = ({
  aggregatedWorkedTime,
  estimatedTimes,
  balances = [],
  extraHoursMinutes = 0,
}: {
  aggregatedWorkedTime?: AggregatedWorkedTimeBlocks | null
  estimatedTimes: TimesheetEstimatedTimeFragment[]
  balances?: TimesheetBalanceFragment[]
  extraHoursMinutes?: number
}) => {
  const today = new Date()

  const workedMinutes = aggregatedWorkedTime?.minutes ?? 0
  const paidBreaksMinutes = aggregatedWorkedTime?.paidBreaksMinutes ?? 0
  const paidAbsencesMinutes = aggregatedWorkedTime?.paidAbsencesMinutes ?? 0
  const effectiveWorkedMinutes = aggregatedWorkedTime?.effectiveWorkedMinutes ?? 0

  const estimatedRecords = estimatedTimes.filter((estimatedTime) => {
    const estimatedDate = new Date(estimatedTime.date)
    return estimatedDate <= today
  })
  const estimatedMinutes = estimatedRecords.reduce(
    (acc, estimatedTime) => acc + (estimatedTime.minutes ?? 0),
    0
  )

  const contractMinutes = estimatedRecords.reduce(
    (acc, estimatedTime) => acc + (estimatedTime.contractMinutes ?? 0),
    0
  )

  const balanceMinutes = balances.reduce((acc, balance) => {
    const dailyBalance = Number(balance.dailyBalanceFromPlanning)
    return acc + (Number.isFinite(dailyBalance) ? dailyBalance : 0)
  }, 0)
  const regularMinutes = aggregatedWorkedTime?.regularMinutes ?? 0
  const extraTimeMinutes = extraHoursMinutes ?? 0
  const workedExtraMinutes = aggregatedWorkedTime?.extraTimeMinutes ?? 0
  const balancedRegularMinutes = regularMinutes + (workedExtraMinutes - extraTimeMinutes)

  const trackedMinutes = aggregatedWorkedTime?.trackedMinutes ?? 0
  const workedTimeBlocks = aggregatedWorkedTime?.workedTimeBlocks ?? []

  const unapprovedOvertimeMinutes = workedTimeBlocks
    .filter((block) => block.timeType === 'overtime' && !block.approved)
    .reduce((sum, block) => sum + (block.minutes || 0), 0)

  const discardedOrAddedMinutes = workedMinutes + unapprovedOvertimeMinutes - trackedMinutes

  return {
    workedMinutes,
    paidBreaksMinutes,
    paidAbsencesMinutes,
    effectiveWorkedMinutes,
    estimatedMinutes,
    contractMinutes,
    balanceMinutes,
    extraTimeMinutes,
    workedExtraMinutes,
    regularMinutes,
    balancedRegularMinutes,
    trackedMinutes,
    unapprovedOvertimeMinutes,
    discardedOrAddedMinutes,
  }
}
